<template>
    <component v-if="resolved" :is="resolved" />
</template>

<script>
import Cow from "./Icons/Cow.vue";
import Cultivo from "./Icons/Cultivo.vue";
import Sorgo from "./Icons/Sorgo.vue";

export default {
  name: "CustomIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 24 }
  },
  computed: {
    icons() {
      return {
        cow: Cow,
        cultivo: Cultivo,
        sorgo: Sorgo
      };
    },
    normalizedName() {
      return (this.name || "").toString().trim().toLowerCase();
    },
    sizePx() {
      const s = String(this.size);
      return /px|em|rem|%$/.test(s) ? s : `${s}px`;
    },
    resolved() {
      return this.icons[this.normalizedName] || null;
    }
  }
};
</script>

<style scoped>
.app-icon {
  display: inline-block;
}

.app-icon ::v-deep svg {
  width: 100%;
  height: 100%;
  display: block;
}
</style>